module.exports = __webpack_public_path__ + "img/icon_menu02.51bc2a6f.png";